import React from "react";
import { useTheme } from "styled-components";

import { TestWrapper } from "@ui/Atoms/TestWrapper";

import { InnerContext } from "../Dialog.context";

import { TitleProps } from "./Title.types";
import * as Styled from "./Title.styled";

export const Title: React.FC<TitleProps> = (props): React.ReactElement => {
  const theme = useTheme();
  const context = React.useContext(InnerContext);

  if (!context) {
    throw new Error("Title component must be used inside Dialog component");
  }

  return (
    <TestWrapper testId={props.testId}>
      <Styled.Title
        modalVariant={context.variant}
        direction={context.direction}
      >
        {!!context.icon && <context.icon width={theme.icons.sizes.base_x4} />}

        <Styled.TextWrapper>
          <Styled.XSpace
            aria-disabled="true"
            modalVariant={context.variant}
            direction={context.direction}
          />
          {props.children}
        </Styled.TextWrapper>
      </Styled.Title>
    </TestWrapper>
  );
};
